import * as d3 from 'd3';

export function Sun(containerId, id, { sunData, weekdayData}, months, seasons, weekdays, props) {
  const { width, height } = props;
  const base = Math.min(width * 0.75, height) / 2;

  const container = document.getElementById(containerId);

  let svg = d3.select('#' + id);
  if (svg.empty()) {
    svg = d3.select(container)
      .append('svg')
      .attr('id', id);
  }
  svg
    .style('width', props.width + 'px')
    .style('height', props.height + 'px');

  new SunRays(svg, 'sunRays', sunData, {
    width, height,
    transitionDuration: props.transitionDuration,
    innerRadius: base * 0.4,
    outerRadius: base * 0.85
  });
  new ArcLabels(svg, 'monthLabels', months, {
    width, height,
    innerRadius: base * 0.34,
    outerRadius: base * 0.39
  });
  new ArcLabels(svg, 'seasonLabels', seasons, {
    width, height,
    innerRadius: base * 0.285,
    outerRadius: base * 0.335
  });
  new Weekdays(svg, 'weekdays', weekdayData, {
    width, height,
    transitionDuration: props.transitionDuration,
    weekdays,
    radius: base * 0.285
  });

  addEvents(seasons, months, weekdays);

}

const format = d3.formatLocale({thousands: ' ', grouping: [3]}).format(',');

function addEvents(seasons, months, weekdays) {

  if (d3.select('#tooltip').empty()) {
    d3.select('#content').append('div').attr('id', 'tooltip').style('left', -1000 + 'px');
  }

  d3.selectAll('#weekdays line')
    .on('mouseenter mousemove', (d, i, nodes) => {
      tooltip(d3.event.x, d3.event.y, weekdays[i] + ': ' + format(d) + ' baleset', true);
      d3.select(nodes[i]).classed('selected', true);
    })
    .on('mouseleave', (d, i, nodes) => {
      tooltip(-1000, d3.event.y, '');
      d3.select(nodes[i]).classed('selected', false);
    });

  d3.selectAll('#sunRays line')
    .on('mouseenter mousemove', (d, i, nodes) => {
      tooltip(d3.event.x, d3.event.y, d.dayLabel + ', ' + d.value + ' baleset', true);
      d3.select(nodes[i]).classed('selected', true);
    })
    .on('mouseleave', (d, i, nodes) => {
      tooltip(-1000, d3.event.y, '', false);
      d3.select(nodes[i]).classed('selected', false);
    });

  const getMonthIndex = n => n + 2 > 11 ? Math.abs(10 - n) : n + 2;
  d3.selectAll('#monthLabels .arcLabel')
    .on('mouseenter mousemove', (d, i, nodes) => {
      const dd = d3.selectAll('#sunRays line.month-' + getMonthIndex(i)).classed('selected', true).data();
      tooltip(d3.event.x, d3.event.y, months[i] + ': ' + format(d3.sum(dd, d => d.value)) + ' baleset', true);
      d3.select(nodes[i]).classed('selected', true);
    })
    .on('mouseleave', (d, i, nodes) => {
      d3.selectAll('#sunRays line.month-' + getMonthIndex(i)).classed('selected', false);
      tooltip(-1000, d3.event.y, '', false);
      d3.select(nodes[i]).classed('selected', false);
    });

  d3.selectAll('#seasonLabels .arcLabel')
    .on('mouseenter mousemove', (d, i, nodes) => {
      d3.selectAll('.season-' + i).classed('selected', true);
      const dd = d3.selectAll('#sunRays .season-' + i).data();
      tooltip(d3.event.x, d3.event.y, seasons[i] + ': ' + format(d3.sum(dd, d => d.value)) + ' baleset', true);
      d3.select(nodes[i]).classed('selected', true);
    })
    .on('mouseleave', (d, i, nodes) => {
      d3.selectAll('.season-' + i).classed('selected', false);
      tooltip(-1000, d3.event.y, '', false);
      d3.select(nodes[i]).classed('selected', false);
    });
}

function tooltip(x, y, text, wide) {
  d3.select('#tooltip')
  .style('left', x + 20 + 'px')
  .style('top', y + 20 + 'px')
  .classed('wide', wide)
  .text(text);
}

// =================================
// weekdays
// =================================
function Weekdays(svg, id, data, props) {
  const {width, height, radius, weekdays} = props;
  const cx = width /2;
  const cy = height /2;

  const t = d3.transition().duration(props.transitionDuration);

  let g = d3.select('#' + id);
  if (g.empty()) {
    g = svg
      .append('g')
      .attr('id', id);
  }

  const chartHeight = radius * .66;
  const scale = d3.scaleLinear()
    .domain([0, d3.max(data)])
    .range([0, -1 * chartHeight]);

  const fontSize = size => size > 8 ? size : 0;

  const chartWidth = radius * 1.5;
  const barWidth = chartWidth * .12;
  const barSpacing = (chartWidth - barWidth * 7) / 6;
  const x = (_, i) => i * (barWidth + barSpacing);
  const enter = enter => {
    const g = enter.append('g')
      .classed('weekday', true)
      .attr('transform', `translate(${cx - chartWidth / 2 + barWidth /2}, ${cy + radius / 3})`);
    g.append('line')
      .attr('x1', x)
      .attr('y1', 0)
      .attr('x2', x)
      .attr('y2', d => scale(d))
      .style('stroke-width', barWidth);

    g.append('text')
      .attr('dy', -1 * chartHeight * 0.05)
      .attr('x', x)
      .attr('font-size', fontSize(barWidth * .45) + 'px')
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'bottom')
      .text((_, i) => weekdays[i]);
  }

  const update = update => {
    update.attr('transform', `translate(${cx - chartWidth / 2 + barWidth /2}, ${cy + radius / 3})`);
    update.select('line')
      .attr('x1', x)
      .attr('y1', 0)
      .attr('x2', x)
      .style('stroke-width', barWidth)
      .call(u =>
          u.transition(t).attr('y2', d => scale(d)));
    update.select('text')
      .attr('dy', -1 * chartHeight * 0.05)
      .attr('x', x)
      .attr('font-size', fontSize(barWidth * .45) + 'px');
  }

  g.selectAll('g.weekday')
    .data(data)
    .join(enter, update);
}

// =================================
// labels
// =================================
function ArcLabels(svg, id, data, props) {
  const { width, height, innerRadius, outerRadius} = props;
  const halfPI = Math.PI / 2;

  let g = d3.select('#' + id);
  if (g.empty()) {
    g = svg
      .append('g')
      .attr('id', id);
  }

  const cx = width / 2;
  const cy = height / 2;

  const labelData = d3.pie()
  .sort(null)
  .value(d => 1)(data);

  const arc = d3.arc()
    .innerRadius(innerRadius)
    .outerRadius(outerRadius)
    .padAngle(0);

  const atBottom = d => {
    const middle = (d.startAngle - halfPI + d.endAngle - halfPI) / 2;
    return middle >= 0 && middle < Math.PI;
  }

  const fontSize = (outerRadius, innerRadius) => {
    const size = (outerRadius - innerRadius) * .7;
    return size > 8 ? size : 0;
  }

  const enter = enter => {
    const g = enter.append('g')
      .attr('class', (_, i) => 'arcLabel' + (data.length === 12 ? ' season-' + Math.floor(i / 3) : ''))
      .attr('transform', `translate(${cx}, ${cy})`);
    g.append('path')
      .classed('labelTextPath', true)
      .attr('id', d => id + '-' + d.index)
      .style('fill', 'none')
      .attr('d', d => {
        const context = d3.path();
        if (atBottom(d)) {
          context.arc(0, 0, (innerRadius + outerRadius) / 2, d.endAngle - halfPI, d.startAngle - halfPI, true);
        } else {
          context.arc(0, 0, (innerRadius + outerRadius) / 2, d.startAngle - halfPI, d.endAngle - halfPI, false);
        }
        return context.toString();
      });
    g.append('path')
      .classed('label', true)
      .attr('d', d => arc(d));
    g.append('text')
      .classed('labelText', true)
      .style('font-size', fontSize(outerRadius, innerRadius) + 'px')
      .attr('dominant-baseline', 'middle')
      .attr('text-anchor', 'middle')
    .append('textPath')
      .attr("startOffset", "50%")
      .attr('xlink:href', d => '#' +id + '-' + d.index)
      .text(d => d.data);
  }

  const update = update => {
    update.attr('transform', `translate(${cx}, ${cy})`);
    update.select('.labelTextPath')
      .attr('d', d => {
        const context = d3.path();
        if (atBottom(d)) {
          context.arc(0, 0, (innerRadius + outerRadius) / 2, d.endAngle - halfPI, d.startAngle - halfPI, true);
        } else {
          context.arc(0, 0, (innerRadius + outerRadius) / 2, d.startAngle - halfPI, d.endAngle - halfPI, false);
        }
        return context.toString();
      });
    update.select('.label')
      .attr('d', d => arc(d));
    update.select('.labelText')
      .style('font-size', fontSize(outerRadius, innerRadius) +  'px');
  }

  g.selectAll('g.arcLabel')
    .data(labelData)
    .join(enter, update);
}

// =================================
// rays
// =================================

function SunRays(svg, id, data, props) {
  const createTransition = () =>
    d3.transition().duration(props.transitionDuration);
  let t = createTransition();

  this.g = d3.select('#' + id);
  if (this.g.empty()) {
    this.g = svg
      .append('g')
      .attr('id', id);
  }

  const q = 360 / 366;

  const onEnter = enter => {
    enter.append('line')
      .attr('class', d => `line month-${d.month} season-${d.season}`)
      .attr('x1', this.cx)
      .attr('y1', this.startY)
      .attr('x2', this.cx)
      .attr('y2', this.startY)
      .attr('transform', d => `rotate(${d.key * q - 60}, ${this.cx}, ${this.cy})`)
      .call(enter => enter.transition(t)
        .attr('x2', this.cx)
        .attr('y2', d => this.startY - this.scale(d.value)));
  }

  const onUpdate = update => {
    update.attr('transform', d => `rotate(${d.key * q - 60}, ${this.cx}, ${this.cy})`)
      .attr('x1', this.cx)
      .attr('y1', this.startY)
      .attr('x2', this.cx)
    update
      .call(update => update.transition(t)
        .attr('y2', d => this.startY - this.scale(d.value)));
  }

  const onExit = exit => {
    exit.call(exit => exit.transition(t))
      .attr('x2', this.cx)
      .attr('y2', this.startY);
  }

  this.data = data => {
    t = createTransition();
    this.dataMax = data.reduce((acc, d) => d.value > acc ? d.value : acc, 0);
    setSizeProps();

    this.g.selectAll('.scale').remove();
    this.g.append('circle')
      .classed('scale', true)
      .attr('cx', this.cx)
      .attr('cy', this.cy)
      .attr('r', props.outerRadius);
    this.g.append('text')
      .classed('scale', true)
      .attr('x', this.cx)
      .attr('y', this.cy - props.outerRadius * .9)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'bottom')
      .text('max: ' + this.dataMax + '/nap');

    this.g.append('text')
      .classed('sum scale', true)
      .attr('x', this.cx)
      .attr('y', this.cy + props.innerRadius * .5)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'bottom')
      .text(format(d3.sum(data, d => d.value)) + ' baleset');

    this.g.append('text')
      .classed('years scale', true)
      .attr('x', this.cx)
      .attr('y', this.cy - props.innerRadius * .4)
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'bottom')
      .html('2015&ndash;2018');


    this.g.selectAll('.line')
      .data(data, d => d.id)
      .join(onEnter, onUpdate, onExit);
  }

  const setSizeProps = () => {
    const { width, height, innerRadius, outerRadius } = props;
    this.cx = width / 2;
    this.cy = height / 2;
    this.startY = this.cy - innerRadius;
    this.scale = d3.scaleLinear()
      .domain([0, this.dataMax])
      .range([0, (outerRadius - innerRadius)]);
  }

  this.redraw = () => {
    t = createTransition();
    setSizeProps();
    onUpdate(d3.select(container).selectAll('.line'));
  }

  this.data(data);
}
